import { Inject, Injectable, signal, WritableSignal,  } from '@angular/core';
import { IElaborazione } from './models/elaborazione.model';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { ELABORAZIONE_ENDPOINT, ELABORAZIONI_ENDPOINT_QUERY_SERVICE_INSTANCE } from './elaborazioni.config';

@Injectable({
  providedIn: 'root'
})
export class ElaborazioneService extends CrudService<IElaborazione> {
  isCheckingElaborazione: WritableSignal<boolean> = signal(false);
  constructor(
    @Inject(ELABORAZIONI_ENDPOINT_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IElaborazione>,
    @Inject(ApiService) protected override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) { 
    super(ELABORAZIONE_ENDPOINT, api, snackbar)
  }
}
